import { CalendarDays, Columns3, List } from "lucide-react";
import { Toggle, ToggleGroup } from "./Toggle";

export type ViewMode = "list" | "board";

const layoutOptionClassName =
  "h-16 flex-col gap-1.5 rounded-md border border-transparent data-pressed:border-border data-pressed:bg-bg data-pressed:shadow-sm [&_svg]:size-5";

export function ViewSwitcher({
  value,
  onChange,
}: {
  value: ViewMode;
  onChange: (value: ViewMode) => void;
}) {
  return (
    <ToggleGroup
      aria-label="View layout"
      value={[value]}
      onValueChange={(values) => {
        const next = values[0];
        if (next === "list" || next === "board") onChange(next);
      }}
      className="grid grid-cols-3 gap-1 rounded-lg bg-surface p-1"
    >
      <Toggle value="list" aria-label="List view" className={layoutOptionClassName}>
        <List />
        List
      </Toggle>
      <Toggle value="board" aria-label="Board view" className={layoutOptionClassName}>
        <Columns3 />
        Kanban
      </Toggle>
      <Toggle
        value="calendar"
        disabled
        aria-label="Calendar view (coming soon)"
        title="Coming soon"
        className={layoutOptionClassName}
      >
        <CalendarDays />
        Calendar
      </Toggle>
    </ToggleGroup>
  );
}
